module.exports = __webpack_public_path__ + "img/08.923872c6.png";